<template>
    <v-app>
        <div class="fullHeight LoginDIV">
            <div class="BGdiv">
                <div class="row content">
                    <div class="col-sm-12 col-md-12 col-lg-6 login-left">
                        <div class="marginAuto">
                            <p class="mainTitle">Enabling Future Discoveries Today</p>
                            <p class="mainDescription">Agrinome for Breeding</p>
                            <p class="mainDescription">First step for the future of agriculture and crop production</p>
                            <br>
                        </div>
                    </div>
                    <div class="col-md-12 col-md-1 col-lg-2 login-middle">
                        <br>
                    </div>
                    <div class="col-md-12 col-md-5 col-lg-4 login-right">
                        <div class="marginAuto widthFullPercentage">
                            <slot />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
export default {
        
};
</script>

<style lang="css" scoped>
.LoginDIV{
	padding: 5rem;
	background-color: #EEEEEE;
}
.BGdiv{
	background-image: url(../../assets/images/loginBG.jpg);
	background-position: center center;
	background-size: cover;
	height: 100%;
	border-radius: 1rem;
	border: 10px solid #192924;
}
.row{
	margin: 0;
}
.content{
	height: 100%;
	overflow: auto;
	padding: 0;
}
.login-left{
	background-color: rgba(25, 43, 39, 0.9);
	color: #fff;
	display: flex;
	padding: 6rem 3rem 6rem 8rem;
}
.login-middle{
	background-color: rgba(25, 43, 39, 0.9);
}
.login-right{
	background-color: #fff;
	display: flex;
	padding: 3rem;
}
.fullHeight{
	min-height: 100vh;
	height: 100vh;
}
.marginAuto{
	margin: auto;
}
.mainTitle{
	font-size: 4.5rem;
	line-height: 4.5rem;
	margin-bottom: 1.5rem;
	font-family: 'Yantramanav', sans-serif;
	color: #f5f5f5;
}
.mainDescription{
	font-size: 16px;
	margin: 0;
	font-family: 'Noto Sans', sans-serif;
	color: #adadad;
}
.btnSignUP{
	width: 110px;
	background-color: #bb4948;
	border-radius: 2px;
	padding: 9px 10px;
	font-weight: 700;
	font-size: 12px;
	font-family: 'Catamaran', monospace;
	letter-spacing: 1px;
}
p{
	margin: 0;
}
.widthFullPercentage{
	width: 100%;
}
.loginForm{
	padding: 3rem;
}
.btnLogin{
	width: 100%;
	background-color: #004D40;
	color: #fff;
	border-radius: 2px;
	padding: 10px 10px;
	font-weight: 700;
	font-size: 12px;
	font-family: 'Catamaran', monospace;
	letter-spacing: 1px;
}
.loginTitle{
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 5px;
	line-height: 26px;
	font-family: 'Open Sans', sans-serif;
}
.loginDescription{
	color: #999999;
}
@media only screen and (max-width: 991px) {
	.LoginDIV{
		padding: 0rem;
		background-color: #EEEEEE;
	}
	.fullHeight{
		min-height: 100vh;
		height: auto; 
	}
	.BGdiv{
		border-radius: 0rem;
		height: 100vh;
		border: none;
	}
	.login-left{
		padding: 3rem;
	}
	.mainTitle{
		font-size: 4rem;
		line-height: 4rem;
		margin-bottom: 1rem;
	}
	.loginForm[data-v-47de6bdd] {
		padding: 0;
	}
}

@media only screen and (max-width: 560px) {
	.mainTitle{
		font-size: 3rem;
		line-height: 3rem;
		margin-bottom: 1rem;
	}
}
</style>
<style>
.v-input .v-label {
	letter-spacing: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/PublicBase.vue